"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.calculatePointsEarnedForOrder = void 0;
const domain_1 = require("@oolio-group/domain");
const EXCLUDED_STATUSES = [domain_1.OrderItemStatus.CANCELLED, domain_1.OrderItemStatus.VOID];
const calculatePointsByAmount = (earningRule, order) => {
    const { totalPrice, totalTax } = order;
    const { amountSpend, earningPoint } = earningRule;
    const pointWillEarn = Math.floor(((totalPrice - (earningRule.includedTax ? 0 : totalTax)) / amountSpend) *
        earningPoint);
    // prevent points to go negative, can happen in the case of free item
    return Math.max(0, pointWillEarn);
};
const calculatePointsByPurchaseItem = (earningRule, order) => {
    const productIds = earningRule.products.map(product => product.id);
    const quantity = order.orderItems.reduce((quantity, item) => {
        if (productIds.includes(item.product.id) &&
            !EXCLUDED_STATUSES.includes(item.status)) {
            return quantity + item.quantity;
        }
        return quantity;
    }, 0);
    const { earningPoint } = earningRule;
    return earningPoint * quantity;
};
const EARNING_RULES_MAP = {
    [domain_1.EarningType.EARN_BY_AMOUNT]: calculatePointsByAmount,
    [domain_1.EarningType.EARN_BY_PURCHASE_ITEM]: calculatePointsByPurchaseItem,
};
const calculatePointsEarnedForOrder = (earningRules, order) => {
    if (!order) {
        return 0;
    }
    return Math.floor(earningRules.reduce((points, earningRule) => {
        var _a;
        return points +
            (((_a = EARNING_RULES_MAP[earningRule.earningType]) === null || _a === void 0 ? void 0 : _a.call(EARNING_RULES_MAP, earningRule, order)) || 0);
    }, 0));
};
exports.calculatePointsEarnedForOrder = calculatePointsEarnedForOrder;
//# sourceMappingURL=loyaltyPointsBalance.js.map